import { getGpBand, parseGpPercent } from 'src/utils/recipeGp'
import { recipeHasNoPricesYet } from 'src/utils/recipeGpReview'

/** Costed recipes only — a shared recipe with no prices yet is not a 0% GP. */
export const getRecipesWithGp = (recipes = []) =>
  (recipes || []).filter(
    recipe =>
      parseGpPercent(recipe?.grossProfit) !== null &&
      !recipeHasNoPricesYet(recipe),
  )

export const countRecipesWithNoPricesYet = (recipes = []) =>
  (recipes || []).filter(recipeHasNoPricesYet).length

export const calculateAverageGp = (recipes = []) => {
  const scored = getRecipesWithGp(recipes)
  if (!scored.length) {
    return null
  }

  const total = scored.reduce(
    (sum, recipe) => sum + parseGpPercent(recipe.grossProfit),
    0,
  )

  return total / scored.length
}

/** Average GP% across costed recipes, colour-coded for list header. */
export const calculateMenuHealthScore = (recipes = []) => {
  const recipeCount = (recipes || []).length
  const scoredRecipes = getRecipesWithGp(recipes)
  const scoredCount = scoredRecipes.length
  const noPricesCount = countRecipesWithNoPricesYet(recipes)
  const avgGp = calculateAverageGp(recipes)

  if (avgGp === null) {
    return {
      avgGp: null,
      band: getGpBand(null),
      recipeCount,
      scoredCount,
      noPricesCount,
      hasScore: false,
      displayValue: '—',
      displayText: '—',
    }
  }

  const rounded = Number.isInteger(avgGp) ? avgGp : Math.round(avgGp * 10) / 10
  const band = getGpBand(avgGp)
  const displayValue = `${
    Number.isInteger(rounded) ? rounded : rounded.toFixed(1)
  }%`

  return {
    avgGp: rounded,
    band,
    recipeCount,
    scoredCount,
    noPricesCount,
    hasScore: true,
    displayValue,
    displayText: displayValue,
  }
}

export const formatMenuHealthLabel = (score, label = 'Average GP%') => {
  if (!score?.hasScore) {
    return `${label}: —`
  }
  return `${label}: ${score.displayValue}`
}
